




















import { Component } from 'vue-property-decorator';
import Edit from '@/layouts/Edit';
import EditBlock from '@/views/CRUD/Edit.vue';
import TitleReturn from '@/components/TitleReturn.vue';
import FormView from './_form.vue';
import ConfirmModal from '@/components/modal/ConfirmModal.vue';
import CPBtn from '@/components/buttons/CPBtn/CPBtn.vue';

import PartnerEntityModule from '@/store/partners/entity';
import ResponseHandlerModule from '@/store/modules/responseHandler';
import { PartnerType, PartnerRequest} from '@/types/models/partners';
import { getApiErrorMessage } from '@/utils/api';
import { strings } from '@/lib/stringConst';
import {Maybe} from "@/types/common";

@Component({
    components: {
        EditBlock,
        TitleReturn,
        FormView,
        ConfirmModal,
        CPBtn,
    },
})
export default class PartnersEditPage extends Edit {
    titleEdit = '';
    formValues: Maybe<PartnerType> = null;
    fieldErrors: Record<string, string> = {};
    isShowModal = false;
    text = strings;

    showModal() {
        this.isShowModal = true;
    }

    closeModal() {
        this.isShowModal = false;
    }

    returnBefore() {
        this.$router.push({ name: 'partners' });
    }

    async update(data: PartnerRequest) {
        this.fieldErrors = {};
        try {
            await PartnerEntityModule.update({ id: this.$route.params.partnersId, data });

            ResponseHandlerModule.showNotify({ message: 'Партнерское предложение обновлено', type: 'ok' });
        } catch (response) {
             const error = response.response.data;

            // unknown fields error
            if (error.message) {
                ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });
                return;
            }

            this.fieldErrors = error.errors.fields || {};
        }
    }

    async removePartner() {
        try {
            await PartnerEntityModule.remove(this.$route.params.partnersId);
            this.returnBefore();
        } catch (response) {
            ResponseHandlerModule.showNotify({ message: getApiErrorMessage(response), type: 'fail' });
        }
    }

    async created() {
        try {
            this.formValues = await PartnerEntityModule.getById(this.$route.params.partnersId);
            this.titleEdit = this.formValues?.title || '';
        } catch (error) {
            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });
        }
    }
}
